import styled from 'styled-components';

// @TODO: this should be part of the <ListItem> in core package
export const ListItemWrapper = styled.div`
    border-bottom: 1px solid #ced6dc;
    &:last-child {
        border: none;
    }
`;
